import { Button, StylovyzeComposableDialog, Text } from '@innovyze/stylovyze';
import { useFormikContext } from 'formik';
import React from 'react';
import { useHistory } from 'react-router-dom';

import { useGlobalization } from '@Translations';
import { addRouteNamespace } from '@Utils/actions';
import { NewIntegrationContainer } from '../../IntegrationsTab.styles';
import { IntegrationTableFormValues } from '../../types/integration.types';
import { Link } from '@mui/material';
import { VaparSettingsFooter } from './VaparSettings.styles';

interface NewIntegrationDialogProps {
	open: boolean;
	onCancel: () => void;
	setWhatIsVaparOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function WhatisVaparDialog({
	open,
	onCancel,
	setWhatIsVaparOpen,
}: NewIntegrationDialogProps) {
	const { t } = useGlobalization();
	const history = useHistory();
	return (
		<StylovyzeComposableDialog
			title={t('VAPAR Integration')}
			onCancel={onCancel}
			open={open}>
			<NewIntegrationContainer>
				<div>
					<Text variant="heading-medium-strong">What is VAPAR</Text>
					VAPAR&apos;s platform gives CCTV Contractors the power to
					automate their pipe inspection and assessment process to
					save time, money, and deliver more value. You must have an
					active VAPAR subscription to continue. Your use of the VAPAR
					platform (including via this integration) is subject to the
					separate terms and conditions for VAPAR&apos;s platform
					and/or the applicable contractual agreement between you and
					VAPAR.{' '}
					<Link
						href="https://www.vapar.co/request-a-quote/"
						target="_blank"
						rel="noreferrer">
						click here
					</Link>{' '}
					to learn more.
				</div>
				<VaparSettingsFooter>
					<Button
						dataCy="cancelButton"
						color="secondary"
						variant="contained"
						onClick={() => {
							setWhatIsVaparOpen(false);
						}}>
						{t('Cancel')}
					</Button>
					<Button
						dataCy="continueButton"
						color="primary"
						variant="contained"
						onClick={() => {
							history.push(
								addRouteNamespace(
									'integrations/vapar-settings',
								),
							);
						}}>
						{t('Continue')}
					</Button>
				</VaparSettingsFooter>
			</NewIntegrationContainer>
		</StylovyzeComposableDialog>
	);
}
